var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.136,
    height: 20.136,
    viewBox: "0 0 20.136 20.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12032.568 11619.568)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 15,
    transform: "translate(-12026 -11617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.443,3.375A10.068,10.068,0,1,0,23.511,13.443,10.073,10.073,0,0,0,13.443,3.375Zm1.016,15.1H12.426v-6.05h2.033Zm0-8.035H12.426V8.409h2.033Z",
    transform: "translate(-12035.943 -11622.943)",
    fill: "#fd5c3c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info_circle.249f8549f746b8a306b981c6434f95d5.svg";
export { ForwardRef as ReactComponent };